// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { IContactPreferenceModel } from './iContactPreferenceModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class IUpdateContactPreferencesModel {
    'accountId': number;
    'contactPreferences': Array<IContactPreferenceModel>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof IUpdateContactPreferencesModel>> = [
        {
            "name":     "accountId",
            "baseName": "accountId",
            "type":     "number"
        },
        {
            "name":     "contactPreferences",
            "baseName": "contactPreferences",
            "type":     "Array<IContactPreferenceModel>"
        },
    ];

    static getAttributeTypeMap() {
        return IUpdateContactPreferencesModel.attributeTypeMap;
    }
}
